/**
 * 尝试进行decodeURIComponent
 * @param {url} url
 * @returns
 */
export const tryDecode = (url) => {
  let newURL = url;
  try {
    newURL = decodeURIComponent(url);
  } catch (err) { }
  return newURL;
};
